export default class OnlyNumbers {

  constructor() {
    this.restrict = 'EA';
    this.require = 'ngModel';
  }

  link(scope, element, attrs, ngModel) {

    function fromUser(text) {
        if (text) {
            var transformedInput = text.replace(/\D/g, '');

            if (transformedInput !== text) {
                ngModel.$setViewValue(transformedInput);
                ngModel.$render();
            }
            return transformedInput;
        }
        return undefined;
    }            
    ngModel.$parsers.push(fromUser);
  }

  static create() {
    return new OnlyNumbers();
  }
}


// WEBPACK FOOTER //
// ./app/js/directives/onlyNumbers.js